import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';

// Lazy load pages for code splitting
import { lazy, Suspense } from 'react';

const LoginPage = lazy(() => import('../pages/Login/LoginPage'));
const ChangePasswordPage = lazy(() => import('../pages/ChangePassword/ChangePasswordPage'));
const DashboardPage = lazy(() => import('../pages/Dashboard/DashboardPage'));
const UsersPage = lazy(() => import('../pages/Users/UsersPage'));
const UserDetailPage = lazy(() => import('../pages/Users/UserDetailPage'));
const AgentsPage = lazy(() => import('../pages/Agents/AgentsPage'));
const AgentDetailPage = lazy(() => import('../pages/Agents/AgentDetailPage'));
const SessionsPage = lazy(() => import('../pages/Sessions/SessionsPage'));
const RateLimitsPage = lazy(() => import('../pages/RateLimits/RateLimitsPage'));
const AuditLogsPage = lazy(() => import('../pages/AuditLogs/AuditLogsPage'));
const HealthPage = lazy(() => import('../pages/Health/HealthPage'));
const AdminsPage = lazy(() => import('../pages/Admins/AdminsPage'));
const BetaAccessPage = lazy(() => import('../pages/BetaAccess/BetaAccessPage'));
const SettingsPage = lazy(() => import('../pages/Settings/SettingsPage'));

function LoadingFallback() {
  return (
    <div className="loading-container">
      <div className="loading-spinner" />
      <p>Loading...</p>
    </div>
  );
}

export function AppRoutes() {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/change-password" element={<ChangePasswordPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/users/:id" element={<UserDetailPage />} />
          <Route path="/agents" element={<AgentsPage />} />
          <Route path="/agents/:id" element={<AgentDetailPage />} />
          <Route path="/sessions" element={<SessionsPage />} />
          <Route path="/rate-limits" element={<RateLimitsPage />} />
          <Route path="/audit-logs" element={<AuditLogsPage />} />
          <Route path="/health" element={<HealthPage />} />
          <Route path="/admins" element={<AdminsPage />} />
          <Route path="/beta-access" element={<BetaAccessPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Route>

        {/* Catch all - redirect to dashboard */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Suspense>
  );
}
